import { Heading, LinkBox, LinkBoxProps, LinkOverlay } from '@chakra-ui/react';

import { Glyph } from '~/components/glyph';
import { trackEvent } from '~/features/analytics/track-event';
import { usePromotion } from '~/features/promotions/hooks/use-promotion';

export function PromotionsBanner(props: LinkBoxProps) {
  const { isLoading, data } = usePromotion();
  const priceCardsBanner = data?.priceCardsBanner;

  if (isLoading || !priceCardsBanner) return null;

  return (
    <LinkBox
      alignItems='center'
      aria-labelledby='promotion-banner-title'
      as='aside'
      bgColor='blue.800'
      borderRadius='lg'
      display='flex'
      gap='16px'
      position='relative'
      _focusWithin={{
        outline: '2px solid',
        outlineOffset: '4px',
        outlineColor: 'blue.500',
      }}
      border={{
        base: '1px solid',
        xl: 'none',
      }}
      borderColor={{
        base: 'white',
        xl: 'none',
      }}
      justifyContent={{
        xl: 'center',
      }}
      padding={{
        base: '16px',
        xl: '16px 20px 16px',
      }}
      {...props}
    >
      <Glyph height={36} name='money-dollar-one' width={36} />
      <Heading
        as='p'
        color='white'
        id='promotion-banner-title'
        size={{
          base: 'marketing-md',
          xl: 'marketing-lg',
        }}
      >
        {priceCardsBanner.text}{' '}
        {Boolean(priceCardsBanner.linkUrl && priceCardsBanner.linkLabel) && (
          <LinkOverlay
            color='accent.lime'
            fontSize='inherit'
            fontWeight='500'
            href={priceCardsBanner.linkUrl!}
            textDecor='underline'
            whiteSpace='nowrap'
            _focus={{
              outline: 'none',
            }}
            onClick={() =>
              trackEvent({
                type: 'click',
                label: 'promotion_banner_clicked',
                name: 'Product Page CTA Clicked',
              })
            }
          >
            {priceCardsBanner.linkLabel}
          </LinkOverlay>
        )}
      </Heading>
    </LinkBox>
  );
}
